/*
 * @FilePath: financeConfig.js
 * @Author: Aron
 * @Date: 2023-07-21 11:27:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-28 20:20:44
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
export default [
  {
    path: "AccountBill",
    name: "AccountBill",
    meta: {
      title: "accountSettlement"
    },
    component: () =>
      import("@/views/Home/financeCenter/AccountBill")
  },
  {
    path: "AccountAssetsBoard",
    name: "AccountAssetsBoard",
    meta: {
      title: "accountAssetDashboard"
    },
    component: () =>
      import("@/views/Home/financeCenter/AccountAssetsBoard")
  },

  {
    path: "AccountChange",
    name: "AccountChange",
    meta: {
      title: "账户变动通知"
    },
    component: () =>
      import("@/views/Home/financeCenter/AccountChange")
  },
  {
    path: "CreateAccountTogether",
    name: "CreateAccountTogether",
    meta: {
      title: "总部共建账户"
    },
    component: () =>
      import("@/views/Home/financeCenter/CreateAccountTogether")
  },{
    path: "RefundRecord",
    name: "RefundRecord",
    meta: {
      title: "退款记录"
    },
    component: () => import("@/views/Home/financeCenter/RefundRecord")
  },
  {
    path: "ControlInvoices",
    name: "ControlInvoices",
    meta: {
      title: "发票管理"
    },
    component: () => import("@/views/Home/financeCenter/ControlInvoices")
  },
  {
    path: "MeaderManagement",
    name: "MeaderManagement",
    meta: {
      title: "发票抬头管理"
    },
    component: () => import("@/views/Home/financeCenter/MeaderManagement")
  },
  {
    path: "GoldAccountManagement",
    name: "GoldAccountManagement",
    meta: {
      title: "金币账户管理"
    },
    component: () =>
      import(
        "@/views/Home/financeCenter/GoldAccountManagement/GoldAccountManagement"
      )
  },
  {
    path: "RegionReturnManage",
    name: "RegionReturnManage",
    meta: {
      title: "权益返还管理"
    },
    component: () => import("@/views/Home/financeCenter/RegionReturnManage")
  },
  {
    path: "ShippingReturnBill",
    name: "ShippingReturnBill",
    meta: {
      title: "月度返还对账单"
    },
    component: () => import("@/views/Home/financeCenter/ShippingReturnBill")
  },
  {
    path: "ReturnDetails",
    name: "ReturnDetails",
    meta: {
      title: "订阅卡返回详情"
    },
    component: () => import("@/views/Home/financeCenter/ReturnDetails")
  },
  {
    path: "ReturnApplication",
    name: "ReturnApplication",
    meta: {
      title: "订阅卡返还列表"
    },
    component: () => import("@/views/Home/financeCenter/ReturnApplication")
  },

  {
    path: "CollectWater",
    name: "CollectWater",
    meta: {
      title: "充值流水"
    },
    component: () =>
      import("@/views/Home/financeCenter/CollectWater/CollectWater")
  },

  {
    path: "AgentAccount",
    name: "AgentAcount",
    meta: {
      title: "现金账户"
    },
    component: () =>
      import("@/views/Home/financeCenter/AgentAccount/AgentAccount")
  },

  {
    path: "CollectWater",
    name: "ReceivingCollectWater",
    meta: {
      title: "收款流水"
    },
    component: () =>
      import("@/views/Home/financeCenter/CollectWater/CollectWater")
  },
  {
    path: "CashAccountManage",
    name: "CashAccountManage",
    meta: {
      title: "提现账户管理"
    },
    component: () =>
      import("@/views/Home/financeCenter/CashAccountManage/CashAccountManage")
  },
  {
    path: "PaymentFlow",
    name: "PaymentFlow",
    meta: {
      title: "支付流水"
    },
    component: () =>
      import("@/views/Home/financeCenter/PaymentFlow/PaymentFlow")
  },
  {
    path: "DeliveryVoucherManage",
    name: "DeliveryVoucherManage",
    meta: {
      title: "提货券管理"
    },
    component: () =>
      import(
        "@/views/Home/financeCenter/DeliveryVoucherManage/DeliveryVoucherManage"
      )
  },
  {
    path: "Exempt",
    name: "Exempt",
    meta: {
      title: "提货券仓储管理费豁免到期查询"
    },
    component: () =>
      import(
        "@/views/Home/financeCenter/Exempt"
      )
  },
  {
    path: "DoubleOrderBalance",
    name: "DoubleOrderBalance",
    meta: {
      title: "双重订单账户余额"
    },
    component: () =>
      import("@/views/Home/financeCenter/DoubleOrderBalance/DoubleOrderBalance")
  },
  // {
  //   path: "DoubleOrderCreation",
  //   name: "DoubleOrderCreation",
  //   meta: {
  //     title: "createDoubleOrder"
  //   },
  //   component: () =>
  //     import(
  //       "@/views/Home/financeCenter/DoubleOrderBalance/DoubleOrderCreation/index.vue"
  //     )
  // },
  {
    path: "VisitReimbursement",
    name: "VisitReimbursement",
    meta: {
      title: "参访报销"
    },
    component: () =>
      import("@/views/Home/financeCenter/VisitReimbursement")
  },
  {
    path: "VisitReimbursementApply",
    name: "VisitReimbursementApply",
    meta: {
      title: "报销申请"
    },
    component: () =>
      import("@/views/Home/financeCenter/VisitReimbursementApply")
  },
  {
    path: "InvoiceHeader",
    name: "InvoiceHeader",
    meta: {
      title: "发票抬头"
    },
    component: () =>
      import("@/views/Home/financeCenter/InvoiceHeader/InvoiceHeader")
  },
  {
    path: "RequestWithdrawal",
    name: "RequestWithdrawal",
    meta: {
      title: "提现申请"
    },
    component: () =>
      import("@/views/Home/financeCenter/RequestWithdrawal")
  },
  {
    path: "ApplicationForCash",
    name: "ApplicationForCash",
    meta: {
      title: "转现金账户申请"
    },
    component: () =>
      import("@/views/Home/financeCenter/ApplicationForCash")
  },
  {
    // 样机指标查询
    path: "SampleIndexQuery",
    name: "SampleIndexQuery",
    component: () => import('@/views/Home/financeCenter/SampleIndexQuery/SampleIndexQuery'),
    meta: {
      title: "样机指标查询"
    }
  },
  {
    // 新标准充电器指标查询
    path: "NewGbChargerIndexQuery",
    name: "NewGbChargerIndexQuery",
    component: () => import('@/views/Home/financeCenter/NewGbChargerIndexQuery/NewGbChargerIndexQuery'),
    meta: {
      title: "新标准充电器指标查询"
    }
  },
  {
    path: "EquipmentToOption",
    name: "EquipmentToOption",
    component: () => import('@/views/Home/financeCenter/EquipmentToOption'),
    meta: {
      title: "资产转期权"
    }
  },
  {
    path: "EquipmentToOptionApply",
    name: "EquipmentToOptionApply",
    component: () => import('@/views/Home/financeCenter/EquipmentToOptionApply'),
    meta: {
      title: "库存设备转期权申请"
    }
  },
  {
    path: "AccountBalanceToOptionApply",
    name: "AccountBalanceToOptionApply",
    component: () => import('@/views/Home/financeCenter/AccountBalanceToOptionApply'),
    meta: {
      title: "账户余额转期权"
    }
  },
  {
    path: "EquityManagement",
    name: "EquityManagement",
    component: () => import('@/views/Home/financeCenter/EquityManagement'),
    meta: {
      title: "权益管理"
    }
  },
  {
    path: "DirectFinReportUpload",
    name: "DirectFinReportUpload",
    component: () => import('@/views/Home/financeCenter/DirectFinReportUpload'),
    meta: {
      title: "直营店财务报表上传"
    }
  },
  {
    path: "DirectStoreReceiptRecord",
    name: "DirectStoreReceiptRecord",
    component: () => import('@/views/Home/financeCenter/DirectStoreReceiptRecord'),
    meta: {
      title: "直营店收款记录"
    }
  },
  {
    path: "EquityDetails",
    name: "EquityDetails",
    component: () => import('@/views/Home/financeCenter/EquityDetails'),
    meta: {
      title: "权益管理详情"
    }
  },
  {
    path: "monthlyBill",
    name: "MonthlyBill",
    meta: {
      title: "月度账单"
    },
    component: () => import("@/views/Home/financeCenter/MonthlyBill")
  },
  {
    path: "monthlyBillDetail",
    name: "MonthlyBillDetail",
    meta: {
      title: "月度账单详情"
    },
    component: () => import("@/views/Home/financeCenter/MonthlyBillDetail")
  }
];
